import { Text } from '@payaca/ambrosia';
import {
  BUILDING_OUTLINE_STYLE,
  type DashedOutlineStyle,
  TITLE_BOUNDARY_STYLE,
} from '@payaca/components/solarRoofView/SolarRoofView';
import { type FC, useId } from 'react';

const SWATCH_WIDTH_PX = 32;
const SWATCH_HEIGHT_PX = 12;

const OutlineSwatch: FC<{ outlineStyle: DashedOutlineStyle }> = (props) => {
  const { outlineStyle } = props;
  return (
    <svg
      aria-hidden
      width={SWATCH_WIDTH_PX}
      height={SWATCH_HEIGHT_PX}
      className="shrink-0 rounded-sm bg-gray-800"
    >
      <line
        x1={0}
        x2={SWATCH_WIDTH_PX}
        y1={SWATCH_HEIGHT_PX / 2}
        y2={SWATCH_HEIGHT_PX / 2}
        stroke={outlineStyle.colour}
        strokeOpacity={outlineStyle.opacity}
        strokeWidth={outlineStyle.weightPx}
        strokeDasharray={`${outlineStyle.dashPx} ${outlineStyle.repeatPx - outlineStyle.dashPx}`}
      />
    </svg>
  );
};

export const MapLegendItem: FC<{
  outlineStyle: DashedOutlineStyle;
  label: string;
}> = (props) => {
  const { outlineStyle, label } = props;
  return (
    <li className="flex items-center gap-2">
      <OutlineSwatch outlineStyle={outlineStyle} />
      <Text as="span" level="supporting">
        {label}
      </Text>
    </li>
  );
};

const MapLegend: FC<{
  showsBuildingOutlines: boolean;
  showsTitleBoundary: boolean;
}> = (props) => {
  const { showsBuildingOutlines, showsTitleBoundary } = props;
  const headingId = useId();
  return (
    <div className="space-y-2">
      <Text id={headingId} level="supporting">
        Legend
      </Text>
      <ul aria-labelledby={headingId} className="space-y-1">
        {showsBuildingOutlines && (
          <MapLegendItem
            outlineStyle={BUILDING_OUTLINE_STYLE}
            label="Building outlines"
          />
        )}
        {showsTitleBoundary && (
          <MapLegendItem
            outlineStyle={TITLE_BOUNDARY_STYLE}
            label="Property boundary"
          />
        )}
      </ul>
    </div>
  );
};

export default MapLegend;
